import { NeedsActivityDto } from '@act/shared/data-transfer-objects';
import { PaginatedTable, PaginatedTableProps } from '@act/storybook';
import { useMemo, useState } from 'react';
import { metaSliceSelectors } from 'redux/slices/metaSlice';
import { AdminToolSkeleton } from '../../AdminToolSkeleton';
import { IndexChildContainer } from 'react-components/member-index/indexContainer';
import { NeedsActivityCreateEdit } from './NeedsActivityCreateEdit';
import { NeedsActitivtiesTableColumns } from './NeedsActivityColumns';

export const NeedsActivity = () => {
  const [createActivity, setCreateActivity] = useState(false);
  const [editActivity, setEditActivity] = useState(false);
  const [selectedActivity, setSelectedActivity] =
    useState<NeedsActivityDto | null>(null);
  const needs = metaSliceSelectors.useSelectNeedsMetadata().data;
  const columns = useMemo(() => {
    return NeedsActitivtiesTableColumns();
  }, [needs?.activities]);

  const NEEDS_ACTIVITIES_ADMIN_TABLE_PROPS: PaginatedTableProps<NeedsActivityDto> =
    {
      data: needs?.activities,
      columnConfig: columns,
      inMemoryPagination: true,
      onRowClick: (row: NeedsActivityDto) => {
        setSelectedActivity(row);
        setEditActivity(true);
      },
    };

  const setFormOpen = (value: boolean) => {
    if (!value) {
      setSelectedActivity(null);
      setEditActivity(false);
    }
  };
  return (
    <>
      <AdminToolSkeleton
        title="Needs Activities"
        toolDescription="Needs activities can be viewed and updated here."
        buttonContent="Add New Needs Activity"
        variant="contained"
        onClick={() => {
          setCreateActivity(true);
        }}
      >
        <IndexChildContainer>
          <PaginatedTable {...NEEDS_ACTIVITIES_ADMIN_TABLE_PROPS} />
        </IndexChildContainer>
      </AdminToolSkeleton>
      {(createActivity || editActivity) && (
        <NeedsActivityCreateEdit
          open={createActivity || editActivity}
          setOpen={createActivity ? setCreateActivity : setFormOpen}
          isEdit={editActivity}
          selectedActivity={selectedActivity}
        />
      )}
    </>
  );
};
